import { DataGrid } from "@mui/x-data-grid/DataGrid";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import React, { useState, useEffect } from "react";
import { EventInfo, EventsListItem, newEventInfo } from "../../data/eventInfo";
import { getEventInfo, saveEventInfo, deleteEventInfo, getEventById } from "../../services/EventInformation"; import { Box, Button, Grid, IconButton, MenuItem, Modal, Pagination, Snackbar, Stack, Switch } from "@mui/material";
import { GridRowId } from "@mui/x-data-grid";
import "./Event.css";
import FormBox from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from "dayjs";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit'; // Add this import
import { randomId } from '@mui/x-data-grid-generator';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import CircularProgress from '@mui/material/CircularProgress';
import ViewListIcon from '@mui/icons-material/ViewList';


type ModalMode = "add" | "edit";
export default function Event({ onShowSessionsClick }: { onShowSessionsClick: (eventId: string) => void }) {
    const [modelMode, setModelMode] = useState<ModalMode>("add");
    const [eventsListItems, setEventsListItems] = useState<EventsListItem[]>([]);
    const [selectedRow, setSelectedRow] = useState<EventsListItem | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newFormValues, setNewFormValues] = useState(newEventInfo());
    const [formValues, setFormValues] = useState(newEventInfo());
    const [loading, setLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarDeleteOpen, setSnackbarDeleteOpen] = useState(false);


    const handleSnackbarDeleteOpen = () => setSnackbarDeleteOpen(true);
    const handleSnackbarDeleteClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarDeleteOpen(false);
    };
    const handleSnackbarOpen = () => setSnackbarOpen(true);
    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };
    useEffect(() => {
        const fetchEventInfo = async () => {
            const eventList = await getEventInfo();
            setEventsListItems(eventList);
        };
        fetchEventInfo();
    }, []);

    const handleRowClick = async (params: any) => {
        const selectedEventId = params.row.Id;
        setSelectedRow(params.row);
        setModelMode("edit");

        // Call getEventById with the selected event's ID
        try {
            const event = await getEventById(selectedEventId);
            setFormValues(event);
            setIsModalOpen(true);
        } catch (error) {
            console.error("Error fetching event info:", error);
        }
    };

    const handleSelectionModelChange = (selectionModel: GridRowId[]) => {
        if (selectionModel.length > 1) {
            alert("Please select only one row");
        } else {
            setSelectedRow(eventsListItems.find((row) => row.Id === selectionModel[0]) || null);
        }
    };
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (selectedRow && modelMode === "edit") {

                console.log(formValues);
                await saveEventInfo(formValues);
                handleSnackbarOpen();

                const updatedEventInfo = await getEventInfo();
                setEventsListItems(updatedEventInfo);

                setIsModalOpen(false);
                const updatedRow = updatedEventInfo.find(info => info.Id === selectedRow.Id);
                setSelectedRow(updatedRow || null);
            } else {
                await submitNewForm();
            }

            setLoading(false);

        } catch (error: any) {
            console.error("Error submitting form:", error);
            alert("Failed to save event information: " + error.message);
        }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target as HTMLInputElement;
        if (modelMode === "add") {
            setNewFormValues((prev) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            setFormValues((prev) => ({
                ...prev,
                [name]: value,
            }));
        };
    };
    const handleButtonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target as HTMLInputElement;
        if (modelMode === "add") {
            setNewFormValues((prev) => ({ ...prev, [name]: checked }));
        } else {
            setFormValues((prev) => ({ ...prev, [name]: checked }));
        }
    };

    const handleClose = () => {
        setIsModalOpen(false);
        setFormValues(newEventInfo());
    };

    const handleAdd = () => {
        setIsModalOpen(true);
        setModelMode("add");
        setNewFormValues(newEventInfo());
        setStatusValue('');
    }


    const handleDelete = async () => {
        try {
            if (selectedRow) {
                // Call the deleteEventInfo function passing the selectedRow
                
                const deleteResponse = await deleteEventInfo(selectedRow);
                if(deleteResponse===null){
                    alert("Failed to delete event information." );
                    return;
                }
                
                setIsModalOpen(false);

                // Filter out the deleted event from the eventInfo array
                const updatedEventInfo = eventsListItems.filter(event => event.Id !== selectedRow.Id);

                // Update the state with the filtered eventInfo
                setEventsListItems(updatedEventInfo);
                //after deletion get the updated event info
                const updatedEventInfoAfterDelete = await getEventInfo();
                setEventsListItems(updatedEventInfoAfterDelete);

                handleSnackbarDeleteOpen();

                // Deselect the row
                setSelectedRow(null);

            } else {
                console.error("No event selected for deletion.");

            }
        } catch (error: any) {
            console.error("Error deleting event info:", error);
            alert("Failed to delete event information: " + error.message);
        }
    };

    const submitNewForm = async () => {
        console.log(newFormValues);
        try {
            newFormValues.Id = randomId();
            await saveEventInfo(newFormValues);
            handleSnackbarOpen();
            setIsModalOpen(false);
            // Fetch updated event info after submission
            const updatedEventInfo = await getEventInfo();
            setEventsListItems(updatedEventInfo);

        } catch (error: any) {
            console.error("Error adding new form entry:", error);
            alert("Failed to save event information: " + error.message);
        }
    };


    interface column {
        field: string;
        headerName: string;
        width: number;
        editable?: boolean;
        renderCell?: (params: any) => JSX.Element;
    }

    const columns: column[] = [
        { field: 'Name', headerName: 'Name', width: 240 },
        {
            field: 'StartDate',
            headerName: 'Start Date',
            width: 180,
            renderCell: (params) => <span>{dayjs(params.value).format('MM/DD/YYYY hh:mm A')}</span>,
        },
        {
            field: 'EndDate', headerName: 'End Date', width: 180,
            renderCell: (params) => <span>{dayjs(params.value).format('MM/DD/YYYY hh:mm A')}</span>,
        },
        {
            field: 'Status',
            headerName: 'Status',
            width: 130,
            renderCell: (params) => {
                let statusLabel = '';
                switch (params.value) {
                    case 1:
                        statusLabel = 'Not Started';
                        break;
                    case 2:
                        statusLabel = 'Active';
                        break;
                    case 3:
                        statusLabel = 'Ended';
                        break;
                    default:
                        statusLabel = 'Unknown';
                }
                return <span>{statusLabel}</span>;
            },
        },
        { field: 'KeynoteSelected', headerName: 'Has Keynote', width: 100 },
        { field: 'CallForSpeakerOpen', headerName: 'Open\nSubmissions', width: 100 },
        { field: "IsWorkshopSessionAllowed", headerName: 'Has Workshop', width: 80 },
        { field: 'SessionsSelected', headerName: 'Sessions Selected', width: 150 },
        {
            field: 'Edit',
            headerName: '',
            width: 100,
            renderCell: (params) => (
                <IconButton
                    onClick={() => handleEditClick(params.row.Id)}
                    aria-label="edit"
                >
                    <EditIcon />
                </IconButton>
            ),
        }
    ];

    const handleEditClick = (eventId: string) => {
        onShowSessionsClick(eventId);
    };

    // State to manage pagination
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Function to get the items for the current page
    const getCurrentItems = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return eventsListItems.slice(startIndex, endIndex);
    };

    // Function to handle pagination
    const handlePageChange = (pageNumber: number) => {
        setCurrentPage(pageNumber);
    };

    //data for the status of the event.
    const statuses = [
        { value: 1, label: 'Not Started' },
        { value: 2, label: 'Active' },
        { value: 3, label: 'Ended' },
    ];
    const [statusValue, setStatusValue] = useState(modelMode === "add" ? newFormValues.Status : formValues.Status);
    // Update statusValue when formValues or newFormValues change
    useEffect(() => {
        // Check if modelMode is "add", if so, use newFormValues, otherwise, use formValues
        const selectedValues = modelMode === "add" ? newFormValues : formValues;

        // Check if selectedValues has a status value and set statusValue accordingly
        if (selectedValues && selectedValues.Status) {
            setStatusValue(selectedValues.Status);
        } else {
            // If there's no status value, set it to an empty string
            setStatusValue('');
        }
    }, [formValues, newFormValues, modelMode]);

    return (
        <Box className="box">
            <Stack direction="row" spacing={2} justifyContent="flex-start">
                <Button variant="contained" className="buttonStyled" color="success" onClick={(handleAdd)} startIcon={<AddIcon />}>Add Event</Button>
            </Stack>
            {eventsListItems.length > 0 ? (
                <DataGrid
                    rows={getCurrentItems()}
                    columns={columns}
                    getRowId={(row) => row.Id}
                    onRowClick={handleRowClick}
                    className="datagrid"
                    // ensure the horizontal scrollbar is always visible
                    autoHeight
                    onRowSelectionModelChange={handleSelectionModelChange}


                />
            ) : (
            <Box sx={{ display: 'flex', alignContent:"center" }}>
                <CircularProgress color="info"/>
            </Box>               
        )}
            <Pagination
                count={Math.ceil(eventsListItems.length / itemsPerPage)}
                page={currentPage}
                onChange={(e, page) => handlePageChange(page)}
                color="primary"
                className="pagination"
            />

            <Modal
                open={isModalOpen}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="modal"
            >
                <FormBox
                    component="form"
                    onSubmit={handleSubmit}
                    className="formBox"
                >
                    <div className="textField">
                        <h4 className="h4">Edit Event: {formValues.Id}</h4>
                        <TextField id="name-input" label="Name" name="Name" fullWidth variant="outlined" onBlur={handleBlur} required
                            defaultValue={modelMode === "add" ? newFormValues.Name : formValues.Name} />

                        <TextField id="Status-input" name="Status" select label="Select a Status" fullWidth variant="outlined" onBlur={handleBlur} required value={statusValue} onChange={(e) => setStatusValue(e.target.value)}>

                            {statuses.map((status) => (
                                <MenuItem key={status.value} value={status.value}>
                                    {status.label}
                                </MenuItem>
                            ))}
                        </TextField>

                        <TextField id="Address1-input" label="Address1" name="Address1" fullWidth variant="outlined" onBlur={handleBlur} required
                            defaultValue={modelMode === "add" ? newFormValues.Address1 : formValues.Address1}
                        />
                        <TextField id="Address2-input" label="Address2" name="Address2" fullWidth className="textfield" variant="outlined"
                            defaultValue={modelMode === "add" ? newFormValues.Address2 : formValues.Address2}

                        />
                        <TextField id="City-input" label="City" name="City" fullWidth variant="outlined" onBlur={handleBlur}
                            defaultValue={modelMode === "add" ? newFormValues.City : formValues.City} required
                        />

                        <TextField id="State-input" label="State" name="State" fullWidth variant="outlined" required
                            defaultValue={modelMode === "add" ? newFormValues.State : formValues.State} onBlur={handleBlur}
                        />
                        <TextField id="Zip-input" label="Zip" name="Zip" fullWidth variant="outlined" required
                            defaultValue={modelMode === "add" ? newFormValues.Zip : formValues.Zip} onBlur={handleBlur}
                        />
                        <TextField id="LocationDescription-input" label="LocationDescription" name="LocationDescription" fullWidth variant="outlined"
                            defaultValue={modelMode === "add" ? newFormValues.LocationDescription : formValues.LocationDescription} onBlur={handleBlur} required
                        />
                        <div>
                            <label>Keynote Selected</label>
                            <Switch
                                name="KeynoteSelected"
                                checked={modelMode === "add" ? newFormValues.KeynoteSelected : formValues.KeynoteSelected}
                                onChange={handleButtonChange}

                                color="warning"
                            />
                            <label>Sessions Selected</label>
                            <Switch
                                name="SessionsSelected"
                                checked={modelMode === "add" ? newFormValues.SessionsSelected : formValues.SessionsSelected}
                                onChange={handleButtonChange}
                                color="warning"
                            />
                            <label>Call For Speakers Is Open</label>
                            <Switch
                                name="CallForSpeakerOpen"
                                checked={modelMode === "add" ? newFormValues.CallForSpeakerOpen : formValues.CallForSpeakerOpen}
                                onChange={handleButtonChange}
                                color="warning"
                            />
                            <label>Has Workshop Sessions</label>
                            <Switch
                                name="IsWorkshopSessionAllowed"
                                checked={modelMode === "add" ? newFormValues.IsWorkshopSessionAllowed : formValues.IsWorkshopSessionAllowed}
                                onChange={handleButtonChange}
                                color="warning"
                            />
                        </div>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
                                        <DateTimePicker
                                            label="Start Date"
                                            name="StartDate"
                                            defaultValue={
                                                modelMode === "add" ? null : dayjs(formValues.StartDate)
                                            }
                                            onChange={(newValue) => {
                                                const isoDate = newValue?.toISOString();
                                                if (modelMode === "add") {
                                                    const yearFromStartDate = newValue?.year();
                                                    const year = yearFromStartDate !== undefined ? yearFromStartDate : 0; // Default value in case of undefined

                                                    setNewFormValues((prevState) => ({
                                                        ...prevState,
                                                        StartDate: isoDate || "",
                                                        Year: year,
                                                    }));
                                                } else {
                                                    const yearFromStartDate = newValue?.year();
                                                    const year = yearFromStartDate !== undefined ? yearFromStartDate : 0; // Default value in case of undefined

                                                    setFormValues((prevState) => ({
                                                        ...prevState,
                                                        StartDate: isoDate || "",
                                                        Year: year,
                                                    }));
                                                }
                                            }
                                            }
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
                                        <DateTimePicker
                                            label="End Date"
                                            name="EndDate"
                                            defaultValue={
                                                modelMode === "add" ?
                                                    null :
                                                    dayjs(formValues.EndDate)}
                                            onChange={(newValue) => {
                                                const isoDate = newValue?.toISOString();
                                                if (modelMode === "add") {
                                                    setNewFormValues({ ...newFormValues, EndDate: isoDate || "" });
                                                } else {
                                                    setFormValues({ ...formValues, EndDate: isoDate || "" });
                                                }
                                            }}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Stack direction="row" spacing={4} marginTop={2}>
                            <Button variant="contained" className="buttonClose" color="secondary" size="large" type="reset" onClick={handleClose}
                            >
                                Close
                            </Button>
                            <LoadingButton
                                loading={loading}
                                loadingPosition="start"
                                startIcon={<SaveIcon />}
                                variant="outlined"
                                type="submit"
                                name="save"
                                className="button"
                            >
                                Save
                            </LoadingButton>

                            <Button variant="contained" className="buttonDelete" color="secondary" onClick={handleDelete} startIcon={<DeleteIcon />}>Delete</Button>
                            <Button variant="contained" className="buttonView" color="info"     onClick={() => onShowSessionsClick(selectedRow?.Id || '')} startIcon={<ViewListIcon />}>View Sessions</Button>
                        </Stack>
                    </div>
                </FormBox>
            </Modal>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                message="Event information saved successfully."
            />
            <Snackbar
                open={snackbarDeleteOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarDeleteClose}
                message="Event information deleted successfully."
            />
        </Box>
    );
}